module.exports = __webpack_public_path__ + "img/es.a3c42774.svg";